import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from 'react-bootstrap';
import { Logo } from '../Common/Logo';
import { CategoryMenu } from '../Common/CategoryMenu';
import SideBarMenu from './SideBarMenu';
import { SearchBox } from '../Common/SearchBox';
import { UserLogin } from '../Common/UserLogin';
import Points from '../../Models/Points';
import ReactTooltip from 'react-tooltip';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge } from 'reactstrap';
import Notifications from '../../Models/Notifications';
import NotificationBadge from 'react-notification-badge';
import { Effect } from 'react-notification-badge';
import logo from '../../assets/images/sharework-logo1web.png';
var striptags = require('striptags');
class NavBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            info: '',
            rem_point: 0,
            x: '',
            count: '',
            messageCount: '',
            allNotifications: [],
            allMessageNotifications: [],
            unreadStatus: [],
            dropdownOpen: { 1: false, 2: false }
        }
        this.getNotification();
        this.getMessageNotification();
        // console.log(JSON.parse(window.localStorage.getItem('info')))
    };

    componentDidMount() {
        window.scrollTo(0, 0)
        if (localStorage.getItem('info')) {
            const x = JSON.parse(localStorage.getItem('info'))
            Points.getPoints(x.id).then(res => {
                if (res.data.status === 200) {
                    this.setState({ rem_point: res.data.payload.remaining_amount })
                } else {
                    this.setState({ rem_point: 0 })
                }

            })
        }
    }

    toggle(id) {
        let s = this.state.dropdownOpen;
        s[id] = !s[id];
        this.setState({ dropdownOpen: s })
        // this.setState(prevState => ({
        //     dropdownOpen[id]: !prevState.dropdownOpen
        // }));
        // this.openStatus();
        this.getNotification();
    }

    toggleMessage(id) {
        let s = this.state.dropdownOpen;
        s[id] = !s[id];
        this.setState({ dropdownOpen: s })
        this.openMessageStatus();
        this.getMessageNotification();
    }

    getNotification() {
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            Notifications.getAll(x.id).then(res => {
                if (res.data.payload !== null) {
                    this.setState({ allNotifications: res.data.payload, count: res.data.count })
                }
            })
        }
    }

    getMessageNotification() {
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            Notifications.getAllMessage(x.id).then(res => {
                if (res.data.payload !== null) {
                    this.setState({ allMessageNotifications: res.data.text, messageCount: res.data.count })
                }
            })
        }
    }

    serviceTransaction(title) {
        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            if (x.user_type_id === 1) {
                return (
                    <Link to={{
                        pathname: `/buyer-transaction`
                    }} style={{ textDecoration: 'none' }} className="category-right request_fonts">
                        <div className="" >
                            {title.substr(0, 17)}...
                        </div>
                    </Link>
                )
            } else if (x.user_type_id === 2) {
                return (
                    <Link to={{
                        pathname: `/seller-transaction`
                    }} style={{ textDecoration: 'none' }} className="category-right request_fonts">
                        <div className="" >
                            {title.substr(0, 17)}...
                        </div>
                    </Link>
                )
            } else if (x.user_type_id === 3) {
                return (
                    <Link to={{
                        pathname: `/affiliator-buyer-transaction`
                    }} style={{ textDecoration: 'none' }} className="category-right request_fonts">
                        <div className="" >
                            {title.substr(0, 17)}...
                        </div>
                    </Link>
                )
            }
        }
    }

    serviceAccept(name, id, seller_id) {
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            if (x.user_type_id === 1) {
                return (
                    <Link to={{
                        pathname: `/buyer-request-estimation-details`,
                        state: { id: id }
                    }} style={{ textDecoration: 'none' }} className="category-right request_fonts">
                        <div className="" >
                            {name.substr(0, 17)}...
                        </div>
                    </Link>
                )
            } else if (x.user_type_id === 2) {
                return (
                    <Link to={{
                        pathname: `/request-details/${id}`,
                        state: { id: id, user: seller_id }
                    }} style={{ textDecoration: 'none' }} className="category-right request_fonts">
                        <div className="" >
                            {name.substr(0, 17)}...
                        </div>
                    </Link>
                )
            } else if (x.user_type_id === 3) {
                return (
                    <Link to={{
                        pathname: `/buyer-request-estimation-details`,
                        state: { id: id }
                    }} style={{ textDecoration: 'none' }} className="category-right request_fonts">
                        <div className="" >
                            {name.substr(0, 17)}...
                        </div>
                    </Link>
                )
            }
        }
    }

    serviceServe(name) {
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            if (x.user_type_id === 1) {
                return (
                    <Link to={{
                        pathname: `/buyer-transaction`
                    }} className="" style={{ textDecoration: 'none' }} className="category-right request_fonts">
                        <div className="" >
                            {name.substr(0, 17)}...
                        </div>
                    </Link>
                )
            } else if (x.user_type_id === 2) {
                return (
                    <Link to={{
                        pathname: `/seller-buyer-transaction`
                    }} className="" style={{ textDecoration: 'none' }} className="category-right request_fonts">
                        <div className="" >
                            {name.substr(0, 17)}...
                        </div>
                    </Link>

                )
            } else if (x.user_type_id === 3) {
                return (
                    <Link to={{
                        pathname: `/affiliator-buyer-transaction`
                    }} className="" style={{ textDecoration: 'none' }} className="category-right request_fonts">
                        <div className="" >
                            {name.substr(0, 17)}...
                        </div>
                    </Link>
                )
            }
        }
    }

    newResponse(name, res_id, pro_id) {
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            if (x.user_type_id === 1) {
                if (pro_id > 0) {
                    return (
                        <Link to={{
                            pathname: `/buyer-request-estimation-details`,
                            state: { id: res_id }
                        }} className="" style={{ textDecoration: 'none' }} className="category-right request_fonts">
                            <div className="" >
                                {name.substr(0, 17)}...
                            </div>
                        </Link>

                    )
                } else {
                    return (
                        <Link to={{
                            pathname: `/buyer-request-details`,
                            state: { id: res_id }
                        }} className="" style={{ textDecoration: 'none' }} className="category-right request_fonts">
                            <div className="" >
                                {name.substr(0, 17)}...
                            </div>
                        </Link>
                    )
                }
            } else if (x.user_type_id === 2) {
                if (pro_id > 0) {
                    return (
                        <Link to={{
                            pathname: `/buyer-request-estimation-details`,
                            state: { id: res_id }
                        }} className="" style={{ textDecoration: 'none' }} className="category-right request_fonts">
                            <div className="" >
                                {name.substr(0, 17)}...
                            </div>
                        </Link>

                    )
                } else {
                    return (
                        <Link to={{
                            pathname: `/seller-buyer-request-details`,
                            state: { id: res_id }
                        }} className="" style={{ textDecoration: 'none' }} className="category-right request_fonts">
                            <div className="" >
                                {name.substr(0, 17)}...
                            </div>
                        </Link>

                    )
                }
            } else if (x.user_type_id === 3) {
                if (pro_id > 0) {
                    return (
                        <Link to={{
                            pathname: `/buyer-request-estimation-details`,
                            state: { id: res_id }
                        }} className="" style={{ textDecoration: 'none' }} className="category-right request_fonts">
                            <div className="" >
                                {name.substr(0, 17)}...
                            </div>
                        </Link>

                    )
                } else {
                    return (
                        <Link to={{
                            pathname: `/affiliator-request-details`,
                            state: { id: res_id }
                        }} className="" style={{ textDecoration: 'none' }} className="category-right request_fonts">
                            <div className="" >
                                {name.substr(0, 17)}...
                            </div>
                        </Link>
                    )
                }
            }
        }
    }

    notificationType(type, name, pro_id, id, res_id, seller_id) {
        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        if (type === 'PURCHASE') {
            return (
                <div className="">
                    {this.serviceTransaction(name)}
                </div>
            )
        } else if (type === 'SYSTEM') {
            return (
                <div className="" >
                    <Link to={{
                        pathname: '/system-notification',
                        state: { id: id }
                    }} style={{ textDecoration: 'none' }} className="category-right request_fonts">
                        <div className="category-right request_fonts">
                            {striptags(name.substr(0, 17))}...
                        </div>
                    </Link>
                </div>
            )
        } else if (type === 'REQUESTDECLINED') {
            return (
                <div className="" ></div>
            )
        } else if (type === 'SERVICERECEIVED') {
            return (
                <div className="">
                    <Link to={{
                        pathname: '/seller-complete-cancel',
                        state: { id: id, type: type }
                        // state:{id:}
                    }} style={{ textDecoration: 'none' }} className="category-right request_fonts"><div className="category-right request_fonts">
                            {name.substr(0, 17)}...
                </div></Link>
                </div>
            )
        } else if (type === 'SERVED') {
            return (
                <div >
                    {this.serviceServe(name)}
                </div>
            )
        } else if (type === 'RESPONSEACCEPTED') {
            return (
                <div >
                    {this.serviceAccept(name, res_id, seller_id)}
                </div>
            )
        } else if (type === 'REQUESTRECEIVED') {
            return (
                <div className=""  >
                    <Link to={{
                        pathname: `/request-details/${res_id}`,
                        state: { id: res_id, type: type }
                        // state:{id:}
                    }} style={{ textDecoration: 'none' }} className="category-right request_fonts"><div className="category-right request_fonts">
                            {name.substr(0, 17)}...
                </div>
                    </Link>
                </div>
            )
        } else if (type === 'RECRUITMENTCLOSED') {
            return (
                <div className="" >
                    <Link to={{
                        pathname: '/request-notification-close',
                        state: { id: id, type: type }
                        // state:{id:}
                    }} style={{ textDecoration: 'none' }} className="category-right request_fonts">
                        <div className="category-right request_fonts">
                            {name.substr(0, 17)}...
                        </div>
                    </Link>
                </div>
            )
        } else if (type === 'FOLLOW') {
            return (
                <div className="" >
                    <Link to={{
                        pathname: '/followers',
                        state: { id: id, type: type }
                        // state:{id:}
                    }} style={{ textDecoration: 'none' }} className="category-right request_fonts">
                        <div className="category-right request_fonts">
                            {name.substr(0, 17)}...
                        </div>
                    </Link>
                </div>
            )
        } else if (type === 'NEWRESPONSE') {
            return (
                <div className="" >
                    {this.newResponse(name, res_id, pro_id)}
                </div>
            )
        } else if (type === 'REVIEW') {
            return (
                <div className="" >
                    <Link to={{
                        pathname: `/categories-details/${pro_id}`,
                        state: { id: pro_id }
                        // state:{id:}
                    }} style={{ textDecoration: 'none' }} className="category-right request_fonts">
                        <div className="category-right request_fonts">
                            {name.substr(0, 17)}...
                        </div>
                    </Link>
                </div>
            )
        } else if (type === 'COMMISSIONRECEIVED') {
            return (
                <div className="" >
                    <Link to={{
                        pathname: `/affiliator-sales-management`,
                        // state: { id: pro_id }
                        // state:{id:}
                    }} style={{ textDecoration: 'none' }} className="category-right request_fonts">
                        <div className="category-right request_fonts" >
                            {name.substr(0, 17)}...
                        </div>
                    </Link>
                </div>
            )
        }
    }

    message(text, id, i, buyerId) {
        var x = JSON.parse(localStorage.getItem('info'))

        if (id === 0 || i === 0) {
            if (x.user_type_id === 2) {
                return (
                    <Link to={{
                        pathname: '/com-with-sys',
                        state: {
                            seller_id: i,
                            buyer_id: id,
                            buyerId: buyerId
                        }
                    }} style={{ textDecoration: 'none' }} className="category-right request_fonts"><div className="category-right request_fonts">
                            {striptags(text)}
                        </div></Link>
                )
            } else if (x.user_type_id === 1) {
                return (
                    <Link to={{
                        pathname: '/com-with-sys',
                        state: {
                            seller_id: id,
                            buyer_id: i
                        }
                    }} style={{ textDecoration: 'none' }} className="category-right request_fonts"><div className="category-right request_fonts">
                            {striptags(text)}
                        </div></Link>
                )
            } else if (x.user_type_id === 3) {
                return (
                    <Link to={{
                        pathname: '/com-with-sys',
                        state: {
                            seller_id: id,
                            buyer_id: i
                        }
                    }} style={{ textDecoration: 'none' }} className="category-right request_fonts">
                        <div className="category-right request_fonts">
                            {striptags(text)}
                        </div>
                    </Link>
                )
            }
        } else {
            if (x.user_type_id === 2) {
                return (
                    <Link to={{
                        pathname: '/seller-direct-message',
                        state: {
                            seller_id: i,
                            buyer_id: id,
                            buyerId: buyerId
                        }
                    }} style={{ textDecoration: 'none' }} className="category-right request_fonts">
                        <div className="category-right request_fonts">
                            {text}
                        </div>
                    </Link >
                )
            } else if (x.user_type_id === 1) {
                return (
                    <Link to={{
                        pathname: '/buyer-direct-message' + '/' + encodeURIComponent(i + "&" + id),
                        state: {
                            seller_id: id,
                            buyer_id: i
                        }
                    }} style={{ textDecoration: 'none' }} className="category-right request_fonts">
                        <div className="category-right request_fonts">
                            {text}
                        </div></Link>
                )
            } else if (x.user_type_id === 3) {
                return (
                    <Link to={{
                        pathname: '/affiliator-direct-message' + '/' + encodeURIComponent(i + "&" + id),
                        state: {
                            seller_id: id,
                            buyer_id: i
                        }
                    }} style={{ textDecoration: 'none' }} className="category-right request_fonts">
                        <div className="category-right request_fonts">
                            {text}
                        </div></Link>
                )
            }
        }
    }

    openStatus() {
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            Notifications.getStatus(x.id).then(res => {
                if (res.data.payload !== null) {
                    this.setState({ unreadStatus: res.data.payload })
                }
            })
        }
    }

    openMessageStatus() {
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            Notifications.openMessageStatus(x.id).then(res => {
                if (res.data.payload !== null) {
                    this.setState({ unreadStatus: res.data.payload })
                }
            })
        }
    }

    notificationIcon() {
        const isMobile = window.innerWidth <= 500;
        //mobile view
        if (isMobile) {
            if (this.state.count === 0) {
                return (
                    <div className=""></div>
                )
            } else {
                return (
                    <Badge color="danger" style={{ height: '17px', position: 'absolute', zIndex: '100', marginTop: '-1px', marginLeft: '-5px' }}>{this.state.count}</Badge>
                )
            }
        }
        //desktop view
        else {
            if (this.state.count === 0) {
                return (
                    <div className=""></div>
                )
            } else {
                return (
                    <Badge color="danger" style={{ height: '17px', position: 'absolute', zIndex: '100', margin: '-5px' }}>{this.state.count}</Badge>
                )
            }
        }
    }

    messageNotification() {
        const isMobile = window.innerWidth <= 500;
        //mobile view
        if (isMobile) {
            if (this.state.messageCount === 0) {
                return (
                    <div className=""></div>
                )
            } else {
                return (
                    <Badge color="danger" style={{ height: '17px', position: 'absolute', zIndex: '100', marginTop: '-1px', marginLeft: '-5px' }}>{this.state.messageCount}</Badge>
                )
            }
        }
        //desktop view
        else {
            if (this.state.messageCount === 0) {
                return (
                    <div className=""></div>
                )
            } else {
                return (
                    <Badge color="danger" style={{ height: '17px', position: 'absolute', zIndex: '100', margin: '-5px' }}>{this.state.messageCount}</Badge>
                )
            }
        }
    }

    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    profilePic() {
        var x = JSON.parse(localStorage.getItem('info'))
        if (localStorage.getItem('pro_pic')) {
            var pro_pic = JSON.parse(localStorage.getItem('pro_pic'))
            return (
                <div  >
                    <img className="" alt="" src={pro_pic} style={{ objectFit: 'cover', marginTop: '11px' }} height="25 " width="25" className="rounded-circle" />
                </div>
            )
        } else {
            return (
                <div >
                    <img className="" alt="" src={x.img_sidebar} style={{ objectFit: 'cover', marginTop: '11px' }} height="25 " width="25" className="rounded-circle" />
                </div>
            )
        }
    }

    login() {
        var x = JSON.parse(localStorage.getItem('info'))
        if (x === null) {
            const isMobile = window.innerWidth <= 500;
            if (isMobile) {
                return (
                    <div >
                        <UserLogin />
                    </div>
                )
            } else {
                return (
                    <UserLogin />
                )
            }
        } else {
            if (parseInt(x.user_type_id) === 2) {
                const isMobile = window.innerWidth <= 500;
                if (isMobile) {
                    return (
                        <div className="row">
                            <div className="col-3 p-0 pt-1 text-center" >
                                <Link to={'/all-notification'}>
                                    <img alt="" src={require("../../assets/images/Notification 2.png")} height="25 " width="25" className="mt-2" />
                                    {this.notificationIcon()}
                                </Link>
                                {/* <Dropdown isOpen={this.state.dropdownOpen[1]} toggle={this.toggle.bind(this, 1)}>
                                    <DropdownToggle style={{ border: '0px #f4f2f0', backgroundColor: '#f4f2f0' }} className="col-md-12 col-12 p-0 mt-2">
                                        <img alt="" src={require("../../assets/images/Notification 2.png")} height="25 " width="25" className="" />
                                        {this.notificationIcon()}
                                    </DropdownToggle>
                                    <DropdownMenu
                                        modifiers={{
                                            setMaxHeight: {
                                                enabled: true,
                                                order: 890,
                                                fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                            ...data.styles,
                                                            overflow: 'auto',
                                                            maxHeight: '350px',
                                                        },
                                                    };
                                                },
                                            },
                                            setMinWidth: {
                                                enabled: true,
                                                order: 890,
                                                fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                            ...data.styles,
                                                            minWidth: '275px',
                                                            left: '4px'
                                                        },
                                                    };
                                                },
                                            },
                                        }}
                                    >
                                        {this.state.allNotifications.map(res =>
                                            <DropdownItem key={res.id} style={{ padding: '1px 8px', borderBottom: '1px solid #ccc', backgroundColor: "#f8f9fa" }}>
                                                <div className="" style={{ padding: "1%" }}>
                                                    {this.notificationType(res.notification_type, res.trimed_text, res.product_id, res.id, res.request_id, res.seller_id)}
                                                </div>
                                            </DropdownItem>
                                        )}
                                        <DropdownItem className="text-center">
                                            <Link to={'/all-notification'} className="request_fonts" style={{ color: "gray", fontSize: "11px" }}>すべて見る</Link>
                                        </DropdownItem>
                                    </DropdownMenu>
                                </Dropdown> */}
                            </div>
                            <div className="col-3 p-0 pt-1 text-center" >
                                <Link to={'/seller-direct-message-list'}>
                                    <img alt="" src={require("../../assets/images/message 2.png")} height="25 " width="25" className="mt-2" />
                                    {this.messageNotification()}
                                </Link>
                                {/* <Dropdown isOpen={this.state.dropdownOpen[2]} toggle={this.toggleMessage.bind(this, 2)}>
                                    <DropdownToggle style={{ border: '0px #f4f2f0', backgroundColor: '#f4f2f0' }} className="col-md-12 col-12 p-0 mt-2">
                                        <img alt="" src={require("../../assets/images/message 2.png")} height="25 " width="25" className="" />
                                        {this.messageNotification()}
                                    </DropdownToggle>
                                    <DropdownMenu
                                        modifiers={{
                                            setMaxHeight: {
                                                enabled: true,
                                                order: 890,
                                                fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                            ...data.styles,
                                                            overflow: 'auto',
                                                            maxHeight: '350px',
                                                        },
                                                    };
                                                },
                                            },
                                            setMinWidth: {
                                                enabled: true,
                                                order: 890,
                                                fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                            ...data.styles,
                                                            minWidth: '275px',
                                                            left: '4px'
                                                        },
                                                    };
                                                },
                                            },
                                        }}
                                    >
                                        {this.state.allMessageNotifications.map((res, i) =>
                                            <DropdownItem key={i} style={{ padding: '3px 8px', borderBottom: '1px solid #ccc', backgroundColor: "#f8f9fa" }}>
                                                <div className="" style={{ padding: "1%" }}>
                                                    {this.message(res.content, res.sender_id, res.receiver_id, res.buyer_id, res.request_id)}
                                                </div>
                                            </DropdownItem>
                                        )}
                                        <DropdownItem className="text-center">
                                            <Link to={'/seller-direct-message-list'} className="" style={{ color: "gray", fontSize: "11px" }}>すべて見る</Link>
                                        </DropdownItem>
                                    </DropdownMenu>
                                </Dropdown> */}
                            </div>
                            <div className="col-3 p-0 text-center" >
                                <Link to={'/seller-dashboard'} >
                                    {this.profilePic()}
                                </Link>
                            </div>
                            <div className="col-3 p-0 pt-1 text-center" >
                                {/* <div className="row"> */}
                                <Link to={'/my-points'} data-tip data-for='sadFace'>
                                    <img alt="" src={require("../../assets/images/Point 2.png")} height="25" width="25" className="mt-2 " />
                                </Link>
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <ul className="justify-content-end collapse navbar-collapse" style={{ marginTop: "0px" }}>
                            <li className="nav-item" >
                                <div className="nav-link">
                                    <Link to={'/all-notification'}>
                                        <img alt="" src={require("../../assets/images/Notification 2.png")} height="32" width="34" className="" style={{ zIndex: '200', position: 'relative' }} />
                                        {this.notificationIcon()}
                                    </Link>
                                </div>
                                {/* <Dropdown isOpen={this.state.dropdownOpen[1]} toggle={this.toggle.bind(this, 1)}>
                                    <DropdownToggle style={{ border: '0px #f4f2f0', backgroundColor: '#f4f2f0' }} className="col-md-12 col-12 p-0 mt-2" >
                                        <img alt="" src={require("../../assets/images/Notification 2.png")} height="32" width="34" className="" style={{ zIndex: '200', position: 'relative' }} />
                                        {this.notificationIcon()}
                                    </DropdownToggle>
                                    <DropdownMenu arrow='true'
                                        modifiers={{
                                            setMaxHeight: {
                                                enabled: true,
                                                order: 890,
                                                fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                            ...data.styles,
                                                            overflow: 'auto',
                                                            maxHeight: '300px',
                                                        },
                                                    };
                                                },
                                            },
                                            setMinWidth: {
                                                enabled: true,
                                                order: 890,
                                                fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                            ...data.styles,
                                                            minWidth: '275px',

                                                        },
                                                    };
                                                },
                                            },
                                            arrow: {
                                                enabled: true,
                                                order: 890,
                                                fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                            ...data.styles,
                                                            borderLeft: '10px solid transparent',
                                                            borderRight: '10px solid transparent',
                                                            borderBottom: '10px solid #000',
                                                            margin: '0 0 15px 0',
                                                            position: 'absolute',

                                                        },
                                                    };
                                                },
                                            },
                                        }
                                        }
                                    >
                                        {this.state.allNotifications.map((res, i) =>
                                            <DropdownItem key={i} style={{ padding: '3px 8px', borderBottom: '1px solid #ccc', backgroundColor: "#f8f9fa" }}>

                                                <div className="" style={{ padding: "1%" }}>
                                                    {this.notificationType(res.notification_type, res.trimed_text, res.product_id, res.id, res.request_id, res.seller_id)}
                                                </div>
                                            </DropdownItem>
                                        )}
                                        <DropdownItem className="text-center">
                                            <Link to={'/all-notification'} className="" style={{ color: "gray", fontSize: "11px" }}>すべて見る</Link>
                                        </DropdownItem>
                                    </DropdownMenu>
                                </Dropdown> */}
                            </li >
                            <li className="nav-item" >
                                <div className="nav-link">
                                    <Link to={'/seller-direct-message-list'}>
                                        <img alt="" src={require("../../assets/images/message 2.png")} height="32" width="34" className="" style={{ zIndex: '200', position: 'relative' }} />
                                        {this.messageNotification()}
                                    </Link>
                                </div>
                                {/* <Dropdown isOpen={this.state.dropdownOpen[2]} toggle={this.toggleMessage.bind(this, 2)}>
                                    <DropdownToggle style={{ border: '0px #f4f2f0', backgroundColor: '#f4f2f0' }} className="col-md-12 col-12 p-0 mt-2 ">
                                        <img alt="" src={require("../../assets/images/message 2.png")} height="32" width="34" className="" style={{ zIndex: '200', position: 'relative' }} />
                                        {this.messageNotification()}
                                    </DropdownToggle>
                                    <DropdownMenu
                                        modifiers={{
                                            setMaxHeight: {
                                                enabled: true,
                                                order: 890,
                                                fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                            ...data.styles,
                                                            overflow: 'auto',
                                                            maxHeight: '300px',
                                                        },
                                                    };
                                                },
                                            },
                                            setMinWidth: {
                                                enabled: true,
                                                order: 890,
                                                fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                            ...data.styles,
                                                            minWidth: '275px',
                                                            left: -65
                                                        },
                                                    };
                                                },
                                            },
                                        }}
                                    >
                                        {this.state.allMessageNotifications.map((res, i) =>
                                            <DropdownItem key={i} style={{ padding: '3px 8px', borderBottom: '1px solid #ccc', backgroundColor: "#f8f9fa" }}>
                                                <div className="" style={{ padding: "1%" }}>
                                                    {this.message(res.content, res.sender_id, res.receiver_id, res.buyer_id, res.request_id)}
                                                </div>
                                            </DropdownItem>
                                        )}
                                        <DropdownItem className="text-center">
                                            <Link to={'/seller-direct-message-list'} className="" style={{ color: "gray", fontSize: "11px" }}>すべて見る</Link>
                                        </DropdownItem>
                                    </DropdownMenu>
                                </Dropdown> */}
                            </li>
                            <li className="nav-item" >
                                <div className="nav-link">
                                    <Link to={'/seller-dashboard'}>
                                        <img alt="" src={require("../../assets/images/Profile 2.png")} height="32" width="34" />
                                    </Link>
                                </div>
                            </li>
                            <li className="nav-item" >
                                <div className="nav-link">
                                    <Link to={'/my-points'} data-tip data-for='sadFace' >
                                        <img alt="" src={require("../../assets/images/Point 2.png")} height="32" width="34" />
                                    </Link>
                                    <ReactTooltip id='sadFace' type='warning' place='bottom' effect='float'>
                                        <span>{parseInt(this.state.rem_point)}</span>
                                    </ReactTooltip>
                                </div>
                            </li>
                        </ul >
                    )
                }
            } else if (parseInt(x.user_type_id) === 1) {
                const isMobile = window.innerWidth <= 500;
                if (isMobile) {
                    return (
                        <div className="row" >
                            <div className="col-3" ></div>
                            {/* <div className="col-6" ></div> */}
                            <div className="col-3 pt-1 p-0 text-center" >
                                <Link to={'/all-notification'}>
                                    <img alt="" src={require("../../assets/images/Notification 2.png")} height="25 " width="25" className="mt-2" />
                                    {this.notificationIcon()}
                                </Link>
                                {/* <Dropdown isOpen={this.state.dropdownOpen[1]} toggle={this.toggle.bind(this, 1)}>
                                    <DropdownToggle className="col-md-12 col-12 p-0 mt-2" style={{ border: '0px #f4f2f0', backgroundColor: '#f4f2f0' }}>
                                        <img alt="" src={require("../../assets/images/Notification 2.png")} height="25 " width="25" className="" />
                                        {this.notificationIcon()}
                                    </DropdownToggle>
                                    <DropdownMenu

                                        modifiers={{
                                            setMaxHeight: {
                                                enabled: true,
                                                order: 890,
                                                fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                            ...data.styles,
                                                            overflow: 'auto',
                                                            maxHeight: '350px',
                                                        },
                                                    };
                                                },
                                            },
                                            setminWidth: {
                                                enabled: true,
                                                order: 890,
                                                fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                            ...data.styles,
                                                            minWidth: '275px',
                                                            left: '4px'
                                                        },
                                                    };
                                                },
                                            },
                                        }}
                                    >
                                        {this.state.allNotifications.map((res, i) =>
                                            <DropdownItem key={i} style={{ padding: '1px 8px', borderBottom: '1px solid #ccc', backgroundColor: "#f8f9fa" }}>
                                                <div className="" style={{ padding: "1%" }}>
                                                    {this.notificationType(res.notification_type, res.trimed_text, res.product_id, res.id, res.request_id)}
                                                </div>
                                            </DropdownItem>
                                        )}
                                        <DropdownItem className="text-center">
                                            <Link to={'/all-notification'} className="" style={{ color: "gray", fontSize: "11px" }}>すべて見る</Link></DropdownItem>
                                    </DropdownMenu>
                                </Dropdown> */}
                            </div>
                            <div className="col-3 pt-1 p-0 text-center" >
                                <Link to={'/buyer-direct-message-list'}>
                                    <img alt="" src={require("../../assets/images/message 2.png")} height="25 " width="" className="mt-2" style={{ zIndex: '200', position: 'relative' }} />
                                    {this.messageNotification()}
                                </Link>
                                {/* <Dropdown isOpen={this.state.dropdownOpen[2]} toggle={this.toggleMessage.bind(this, 2)}>
                                    <DropdownToggle style={{ border: '0px #f4f2f0', backgroundColor: '#f4f2f0' }} className="col-md-12 col-12 p-0 mt-2" >
                                        <img alt="" src={require("../../assets/images/message 2.png")} height="25 " width="" className="" style={{ zIndex: '200', position: 'relative' }} />
                                        {this.messageNotification()}
                                    </DropdownToggle>
                                    <DropdownMenu
                                        modifiers={{
                                            setMaxHeight: {
                                                enabled: true,
                                                order: 890,
                                                fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                            ...data.styles,
                                                            overflow: 'auto',
                                                            maxHeight: '350px',
                                                        },
                                                    };
                                                },
                                            },
                                            setminWidth: {
                                                enabled: true,
                                                order: 890,
                                                fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                            ...data.styles,
                                                            // overflow: 'auto',
                                                            minWidth: '275px',
                                                            left: '4px'
                                                        },
                                                    };
                                                },
                                            },
                                        }}
                                    >
                                        {this.state.allMessageNotifications.map((res, i) =>
                                            <DropdownItem key={i} style={{ padding: '1px 8px', borderBottom: '1px solid #ccc', backgroundColor: "#f8f9fa" }}>
                                                <div className="" style={{ padding: "1%" }}>
                                                    {this.message(res.content, res.sender_id, res.receiver_id, res.buyer_id)}
                                                </div>
                                            </DropdownItem>
                                        )}
                                        <DropdownItem className="text-center">
                                            <Link to={'/buyer-direct-message-list'} className="" style={{ color: "gray", fontSize: "11px" }}>すべて見る</Link>
                                        </DropdownItem>
                                    </DropdownMenu>
                                </Dropdown> */}
                            </div>
                            <div className="col-3 p-0 text-center" >
                                <Link to={'/buyer-dashboard'}>
                                    {this.profilePic()}
                                </Link>
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <ul className="justify-content-end collapse navbar-collapse" style={{ marginTop: "0px" }}>
                            <li className="nav-item" >
                                <div className="nav-link">
                                    <Link to={'/all-notification'}>
                                        <img alt="" src={require("../../assets/images/Notification 2.png")} height="32" width="34" className="" style={{ zIndex: '200', position: 'relative' }} />
                                        {this.notificationIcon()}
                                    </Link>
                                </div>
                                {/* <Dropdown isOpen={this.state.dropdownOpen[1]} toggle={this.toggle.bind(this, 1)}>
                                    <DropdownToggle style={{ border: '0px #f4f2f0', backgroundColor: '#f4f2f0' }} className="col-md-12 col-12 p-0 mt-2" >
                                        <img alt="" src={require("../../assets/images/Notification 2.png")} height="32 " width="34" className="" style={{ zIndex: '200', position: 'relative' }} />
                                        {this.notificationIcon()}
                                    </DropdownToggle>
                                    <DropdownMenu
                                        modifiers={{
                                            setMaxHeight: {
                                                enabled: true,
                                                order: 890,
                                                fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                            ...data.styles,
                                                            overflow: 'auto',
                                                            maxHeight: '300px',

                                                        },
                                                    };
                                                },
                                            },
                                            setminWidth: {
                                                enabled: true,
                                                order: 890,
                                                fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                            ...data.styles,
                                                            // overflow: 'auto',
                                                            minWidth: '275px',

                                                        },
                                                    };
                                                },
                                            },
                                        }}
                                    >
                                        {this.state.allNotifications.map((res, i) =>
                                            <DropdownItem key={i} style={{ padding: '1px 8px', borderBottom: '1px solid #ccc', backgroundColor: "#f8f9fa" }}>
                                                <div className="" style={{ padding: "1%" }}>
                                                    {this.notificationType(res.notification_type, res.trimed_text, res.product_id, res.id, res.request_id)}
                                                </div>
                                            </DropdownItem>
                                        )}
                                        <DropdownItem className="text-center">
                                            <Link to={'/all-notification'} className="" style={{ color: "gray", fontSize: "11px" }}>すべて見る</Link></DropdownItem>
                                    </DropdownMenu>
                                </Dropdown> */}
                            </li>
                            <li className="nav-item" >
                                <div className="nav-link">
                                    <Link to={'/buyer-direct-message-list'}>
                                        <img alt="" src={require("../../assets/images/message 2.png")} height="32" width="34" className="" style={{ zIndex: '200', position: 'relative' }} />
                                        {this.messageNotification()}
                                    </Link>
                                </div>
                                {/* <Dropdown isOpen={this.state.dropdownOpen[2]} toggle={this.toggleMessage.bind(this, 2)}>
                                    <DropdownToggle style={{ border: '0px #f4f2f0', backgroundColor: '#f4f2f0' }} className="col-md-12 col-12 p-0 mt-2" aria-haspopup data-toggle nav>
                                        <img alt="" src={require("../../assets/images/message 2.png")} height="32" width="34" className="" style={{ zIndex: '200', position: 'relative' }} />
                                        {this.messageNotification()}
                                    </DropdownToggle>
                                    <DropdownMenu
                                        modifiers={{
                                            setMaxHeight: {
                                                enabled: true,
                                                order: 890,
                                                fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                            ...data.styles,
                                                            overflow: 'auto',
                                                            maxHeight: '300px',
                                                        },
                                                    };
                                                },
                                            },
                                            setminWidth: {
                                                enabled: true,
                                                order: 890,
                                                fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                            ...data.styles,
                                                            // overflow: 'auto',
                                                            minWidth: '275px',
                                                            left: -65
                                                        },
                                                    };
                                                },
                                            },
                                        }} >
                                        {this.state.allMessageNotifications.map((res, i) =>
                                            <DropdownItem key={i} style={{ padding: '1px 8px', borderBottom: '1px solid #ccc', backgroundColor: "#f8f9fa" }}>
                                                <div className="" style={{ padding: "1%" }}>
                                                    {this.message(res.content, res.sender_id, res.receiver_id, res.buyer_id)}
                                                </div>
                                            </DropdownItem>
                                        )}
                                        <DropdownItem className="text-center">
                                            <Link to={'/buyer-direct-message-list'} className="" style={{ color: "gray", fontSize: "11px" }}>すべて見る</Link>
                                        </DropdownItem>
                                    </DropdownMenu>
                                </Dropdown> */}
                            </li>
                            <li className="nav-item" >
                                <div className="nav-link">
                                    <Link to={'/buyer-dashboard'}>
                                        <img alt="" src={require("../../assets/images/Profile 2.png")} height="32" width="34" />
                                    </Link>
                                </div>
                            </li>
                        </ul >
                    )
                }
            } else if (parseInt(x.user_type_id) === 3) {
                const isMobile = window.innerWidth <= 500;
                if (isMobile) {
                    return (
                        <div className="row">
                            <div className="col-3 pt-1 p-0 text-center" >
                                <Link to={'/all-notification'} >
                                    <img alt="" src={require("../../assets/images/Notification 2.png")} height="25 " width="25" className="mt-2" style={{ zIndex: '200', position: 'relative' }} />
                                    {this.notificationIcon()}
                                </Link>
                                {/* <Dropdown isOpen={this.state.dropdownOpen[1]} toggle={this.toggle.bind(this, 1)}>
                                    <DropdownToggle style={{ border: '0px #f4f2f0', backgroundColor: '#f4f2f0' }} className="col-md-12 col-12 p-0 mt-2">
                                        <img alt="" src={require("../../assets/images/Notification 2.png")} height="25 " width="25" className="" style={{ zIndex: '200', position: 'relative' }} />
                                        {this.notificationIcon()}
                                    </DropdownToggle>
                                    <DropdownMenu
                                        modifiers={{
                                            setMaxHeight: {
                                                enabled: true,
                                                order: 890,
                                                fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                            ...data.styles,
                                                            overflow: 'auto',
                                                            maxHeight: 350,
                                                        },
                                                    };
                                                },
                                            },
                                            setminWidth: {
                                                enabled: true,
                                                order: 890,
                                                fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                            ...data.styles,
                                                            // overflow: 'auto',
                                                            minWidth: 275,
                                                            left: 4
                                                        },
                                                    };
                                                },
                                            },
                                        }} >
                                        {this.state.allNotifications.map((res, i) =>
                                            <DropdownItem key={i} style={{ padding: '3px 8px', borderBottom: '1px solid #ccc', backgroundColor: "#f8f9fa" }}>
                                                <div className="" style={{ padding: "1%" }}>
                                                    {this.notificationType(res.notification_type, res.trimed_text, res.product_id, res.id, res.request_id)}
                                                </div>
                                            </DropdownItem>
                                        )}
                                        <DropdownItem className="text-center">
                                            <Link to={'/all-notification'} className="" style={{ color: "gray", fontSize: "11px" }}>すべて見る</Link></DropdownItem>
                                    </DropdownMenu>
                                </Dropdown> */}
                            </div>
                            <div className="col-3 pt-1 p-0 text-center" >
                                <Link to={'/affiliator-direct-message-list'} >
                                    <img alt="" src={require("../../assets/images/message 2.png")} height="25 " width="25" className="mt-2" style={{ zIndex: '200', position: 'relative' }} />
                                    {this.messageNotification()}
                                </Link>
                                {/* <Dropdown isOpen={this.state.dropdownOpen[2]} toggle={this.toggleMessage.bind(this, 2)}>
                                    <DropdownToggle style={{ border: '0px #f4f2f0', backgroundColor: '#f4f2f0' }} className="col-md-12 col-12 p-0 mt-2">
                                        <img alt="" src={require("../../assets/images/message 2.png")} height="25 " width="25" className="" style={{ zIndex: '200', position: 'relative' }} />
                                        {this.messageNotification()}
                                    </DropdownToggle>
                                    <DropdownMenu
                                        modifiers={{
                                            setMaxHeight: {
                                                enabled: true,
                                                order: 890,
                                                fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                            ...data.styles,
                                                            overflow: 'auto',
                                                            maxHeight: 350,
                                                        },
                                                    };
                                                },
                                            },
                                            setMinWidth: {
                                                enabled: true,
                                                order: 890,
                                                fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                            ...data.styles,
                                                            minWidth: 275,
                                                            left: 4
                                                        },
                                                    };
                                                },
                                            },
                                        }}
                                    >
                                        {this.state.allMessageNotifications.map((res, i) =>
                                            <DropdownItem key={i} style={{ padding: '3px 8px', borderBottom: '1px solid #ccc', backgroundColor: "#f8f9fa" }}>
                                                <div className="" style={{ padding: "1%" }}>
                                                    {this.message(res.content, res.sender_id, res.receiver_id, res.buyer_id)}
                                                </div>
                                            </DropdownItem>
                                        )}
                                        <DropdownItem className="text-center">
                                            <Link to={'/affiliator-direct-message-list'} className="" style={{ color: "gray", fontSize: "11px" }}>すべて見る</Link>
                                        </DropdownItem>
                                    </DropdownMenu>
                                </Dropdown> */}
                            </div>
                            <div className="col-3 p-0 pt-1" style={{ textAlign: 'center' }}>
                                <Link to={'/affiliator-dashboard'} >
                                    {this.profilePic()}
                                    {/* <img alt="" src={require("../../assets/images/Profile 2.png")} height="25 " width="25" className="mt-3 " /> */}
                                </Link>
                            </div>
                            <div className="col-3 pt-1 p-0 pt-1" style={{ textAlign: 'center' }}>
                                <Link to={'/affiliator-my-points'} data-tip data-for='sadFace'>
                                    <img alt="" src={require("../../assets/images/Point 2.png")} height="25 " width="25" className="mt-2 " />
                                </Link>
                                {/* <ReactTooltip id='sadFace' type='warning' place='bottom' effect='float'>
                                    <span>{parseInt(this.state.rem_point)}</span>
                                </ReactTooltip> */}
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <ul className="justify-content-end collapse navbar-collapse" style={{ marginTop: "0px" }}>
                            <li className="nav-item" >
                                <div className="nav-link">
                                    <Link to={'/all-notification'}>
                                        <img alt="" src={require("../../assets/images/Notification 2.png")} height="32" width="34" className="" style={{ zIndex: '200', position: 'relative' }} />
                                        {this.notificationIcon()}
                                    </Link>
                                </div>
                                {/* <Dropdown isOpen={this.state.dropdownOpen[1]} toggle={this.toggle.bind(this, 1)}>
                                    <DropdownToggle style={{ border: '0px #f4f2f0', backgroundColor: '#f4f2f0' }} className="col-md-12 col-12 p-0 mt-2">
                                        <img alt="" src={require("../../assets/images/Notification 2.png")} height="32 " width="34" className="" style={{ zIndex: '200', position: 'relative' }} />
                                        {this.notificationIcon()}
                                    </DropdownToggle>

                                    <DropdownMenu
                                        modifiers={{
                                            setMaxHeight: {
                                                enabled: true,
                                                order: 890,
                                                fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                            ...data.styles,
                                                            overflow: 'auto',
                                                            maxHeight: 300,
                                                        },
                                                    };
                                                },
                                            },
                                            setMinWidth: {
                                                enabled: true,
                                                order: 890,
                                                fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                            ...data.styles,
                                                            minWidth: 275,
                                                        },
                                                    };
                                                },
                                            },
                                        }}
                                    >
                                        {this.state.allNotifications.map((res, i) =>
                                            <DropdownItem key={i} style={{ padding: '1px 8px', borderBottom: '1px solid #ccc', backgroundColor: "#f8f9fa" }}>
                                                <div className="" style={{ padding: "1%" }}>
                                                    {this.notificationType(res.notification_type, res.trimed_text, res.product_id, res.id, res.request_id)}
                                                </div>
                                            </DropdownItem>
                                        )}
                                        <DropdownItem className="text-center">
                                            <Link to={'/all-notification'} className="" style={{ color: "gray", fontSize: "11px" }}>すべて見る</Link></DropdownItem>
                                    </DropdownMenu>
                                </Dropdown> */}
                            </li>
                            <li className="nav-item" >
                                <div className="nav-link">
                                    <Link to={'/affiliator-direct-message-list'}>
                                        <img alt="" src={require("../../assets/images/message 2.png")} height="32" width="34" className="" style={{ zIndex: '200', position: 'relative' }} />
                                        {this.messageNotification()}
                                    </Link>
                                </div>
                                {/* <Dropdown isOpen={this.state.dropdownOpen[2]} toggle={this.toggleMessage.bind(this, 2)}>
                                    <DropdownToggle style={{ border: '0px #f4f2f0', backgroundColor: '#f4f2f0' }} className="col-md-12 col-12 p-0 mt-2">
                                        <img alt="" src={require("../../assets/images/message 2.png")} height="32" width="34" className="" style={{ zIndex: '200', position: 'relative' }} />
                                        {this.messageNotification()}
                                    </DropdownToggle>
                                    <DropdownMenu
                                        modifiers={{
                                            setMaxHeight: {
                                                enabled: true,
                                                order: 890,
                                                fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                            ...data.styles,
                                                            overflow: 'auto',
                                                            maxHeight: 300,
                                                        },
                                                    };
                                                },
                                            },
                                            setMinWidth: {
                                                enabled: true,
                                                order: 890,
                                                fn: (data) => {
                                                    return {
                                                        ...data,
                                                        styles: {
                                                            ...data.styles,
                                                            minWidth: 275,
                                                            left: -65
                                                        },
                                                    };
                                                },
                                            },
                                        }}
                                    >
                                        {this.state.allMessageNotifications.map((res, i) =>
                                            <DropdownItem key={i} style={{ padding: '3px 8px', borderBottom: '1px solid #ccc', backgroundColor: "#f8f9fa" }}>
                                                <div className="" style={{ padding: "1%" }}>
                                                    {this.message(res.content, res.sender_id, res.receiver_id, res.buyer_id)}
                                                </div>
                                            </DropdownItem>
                                        )}
                                        <DropdownItem className="text-center">
                                            <Link to={'/affiliator-direct-message-list'} className="" style={{ color: "gray", fontSize: "11px" }}>すべて見る</Link>
                                        </DropdownItem>
                                    </DropdownMenu>
                                </Dropdown> */}
                            </li>
                            <li className="nav-item" >
                                <div className="nav-link">
                                    <Link to={'/affiliator-dashboard'}>
                                        <img alt="" src={require("../../assets/images/Profile 2.png")} height="32" width="34" className=" " />
                                    </Link>
                                </div>
                            </li>
                            <li className="nav-item" >
                                <div className="nav-link">
                                    <Link to={'/affiliator-my-points'} data-tip data-for='sadFace'>
                                        <img alt="" src={require("../../assets/images/Point 2.png")} height="32" width="34" className="" />
                                    </Link>
                                    <ReactTooltip id='sadFace' type='warning' place='bottom' effect='float'>
                                        <span>{parseInt(this.state.rem_point)}</span>
                                    </ReactTooltip>
                                </div>
                            </li>
                        </ul>
                    )
                }
            }
        }
    }

    menu() {
        if (!localStorage.getItem('info')) {
            console.log('asd')
            return (
                // <div>
                <div className="col-5"><CategoryMenu /></div>
                // </div>
            )
        } else {
            if (window.location.pathname === '/' || window.location.pathname === '/post-request' || window.location.pathname === '/request' || window.location.pathname === '/transaction-flow' || window.location.pathname === '/contact-us' || window.location.pathname === '/affiliator-application' || window.location.pathname === '/terms-conditions' || window.location.href.match("/categories-details/") || window.location.href.match("/payment/") || window.location.href.match("/sub-categories/") || window.location.href.match("/categories/") || window.location.href.match("/buyer-ask-estimate/") || window.location.href.match("/request-confirm/")) {
                return (
                    <div className="col-5">
                        <div ><CategoryMenu /></div>
                    </div>
                )
            }
            else {
                return (
                    <div className="col-5" style={{ paddingLeft: '18px' }}>
                        <div ><SideBarMenu /></div>
                    </div>
                )
            }
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        if (isMobile) {
            return (
                <div>
                    <Navbar fixed="top">
                        <div className="header_area">
                            <div className="header" style={{ height: "50px" }}>
                                <div className="container" style={{ paddingLeft: '15px', paddingRight: '15px' }}>
                                    <div className="row">
                                        {/* <div className="" style={{ width: '6%' }}></div> */}
                                        <div className="col-4" style={{ paddingLeft: '10px' }}>
                                            <Link to={"/"}><img className="logo_img_res" alt="" src={logo} /></Link>
                                        </div>
                                        <div className="col-2" ></div>
                                        <div className="col-6" style={{ paddingRight: '20px' }}>
                                            {this.login()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className=" second_header_area">
                                {/* <div className="container"> */}
                                <div className="row">
                                    {this.menu()}

                                    <div className="row search_area col-7" >
                                        <form>
                                            <div className="row" style={{ width: '100%', marginLeft: '15px' }}>
                                                <div className="mt-2" style={{ paddingRight: '0px', width: '75%', textAlign: 'right' }}>
                                                    <input style={{ width: '92%', height: '28px' }} type="text" placeholder="" onChange={this.updateValue.bind(this, "searchkey")} />
                                                </div>
                                                <div className="mt-2" style={{ width: '15%' }}>
                                                    <Link to={{
                                                        pathname: `/search-results/${this.state.searchkey}`,
                                                        state: { id: this.state.searchkey }
                                                    }}>
                                                        <button type="submit" style={{ border: '0px solid #ccc', backgroundColor: 'white', width: '35px', height: '28px' }}><i className="fas fa-search" style={{ opacity: '0.2' }}></i></button>
                                                    </Link>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            {/* </div> */}
                        </div>
                    </Navbar>
                </div>
            );
        } else {
            return (
                <div>
                    <Navbar fixed="top" className="navbar-expand-lg">
                        <div className="header_area ">
                            {/* <div className="container-fluid"> */}
                            <div className="header">
                                <div className="container">
                                    <ul className="row" style={{ marginTop: '0px', marginLeft: '0px' }}>
                                        <li className="mobile_logo">
                                            <Logo />
                                        </li>
                                        {this.login()}
                                    </ul>
                                </div>

                            </div>
                            <div className=" second_header_area">
                                <div className="container">
                                    <ul className="row" style={{ marginTop: '0px' }}>
                                        <li className="catagory ">
                                            <CategoryMenu />
                                        </li>
                                        {/* <div className="col-md-2 catagory">
                                        </div> */}
                                        <li className="justify-content-start collapse navbar-collapse">
                                            <SearchBox />
                                        </li>
                                        {/* <div className="col-md-4 text-right">
                                        </div> */}
                                    </ul>

                                </div>
                            </div>
                        </div>
                    </Navbar>
                </div>
            );
        }

    }
}

export { NavBar };